import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 用户中心侧边栏组件
 *
 * 展示内置的"个人信息"入口和第三方注册的 slot 入口。
 */
import * as React from 'react';
import { useRoute } from '@hvsin/mod-route';
import { PROFILE_SECTION_ID } from '@hvsin/user-center-contracts';
import { ProfileIcon, DefaultSlotIcon } from './icons.js';
/**
 * 用户中心侧边栏
 */
export function Sidebar({ slots }) {
    const { useSearchParams } = useRoute();
    const [searchParams, setSearchParams] = useSearchParams();
    const activeSection = searchParams.get('section') || PROFILE_SECTION_ID;
    /**
     * 切换到指定 section
     */
    const handleNavigate = (sectionId) => {
        setSearchParams({ section: sectionId });
    };
    return (_jsxs("aside", { style: styles.sidebar, children: [_jsxs("div", { style: styles.userPanel, children: [_jsx("div", { style: styles.avatarSmall, children: "\uD83D\uDC64" }), _jsx("span", { style: styles.userPanelText, children: "\u7528\u6237\u4E2D\u5FC3" })] }), _jsxs("nav", { style: styles.nav, children: [_jsx("p", { style: styles.navTitle, children: "\u5BFC\u822A\u83DC\u5355" }), _jsx(NavItem, { icon: _jsx(ProfileIcon, {}), label: "\u4E2A\u4EBA\u4FE1\u606F", isActive: activeSection === PROFILE_SECTION_ID, onClick: () => handleNavigate(PROFILE_SECTION_ID) }), slots.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { style: styles.divider }), _jsx("p", { style: styles.navTitle, children: "\u6269\u5C55\u529F\u80FD" }), slots.map(slot => (_jsx(NavItem, { icon: slot.icon ? _jsx(slot.icon, {}) : _jsx(DefaultSlotIcon, {}), label: slot.label, isActive: activeSection === slot.id, onClick: () => handleNavigate(slot.id) }, slot.id)))] }))] }), _jsx("div", { style: styles.footer, children: _jsx("span", { style: styles.footerText, children: "v1.0.0" }) })] }));
}
/** 导航条目组件 */
function NavItem({ icon, label, isActive, onClick }) {
    const [hovered, setHovered] = React.useState(false);
    return (_jsxs("button", { onClick: onClick, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), style: {
            ...styles.navItem,
            backgroundColor: isActive ? '#eef2ff' : hovered ? '#f9fafb' : 'transparent',
            color: isActive ? '#4f46e5' : '#374151',
            fontWeight: isActive ? 600 : 500,
        }, children: [_jsx("span", { style: {
                    ...styles.navIcon,
                    color: isActive ? '#6366f1' : '#9ca3af',
                }, children: icon }), _jsx("span", { style: styles.navLabel, children: label }), isActive && _jsx("span", { style: styles.activeIndicator })] }));
}
const styles = {
    sidebar: {
        width: '240px',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #e5e7eb',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        position: 'sticky',
        top: 0,
    },
    userPanel: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '20px 16px',
        borderBottom: '1px solid #f3f4f6',
    },
    avatarSmall: {
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#6366f1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px',
        color: 'white',
    },
    userPanelText: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#111827',
    },
    nav: {
        flex: 1,
        padding: '12px 8px',
        overflowY: 'auto',
    },
    navTitle: {
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: '#9ca3af',
        margin: '8px 8px 4px',
        padding: '0 4px',
    },
    navItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        padding: '10px 12px',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        textAlign: 'left',
        transition: 'all 0.15s ease',
        position: 'relative',
    },
    navIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    navLabel: {
        flex: 1,
    },
    activeIndicator: {
        width: '4px',
        height: '20px',
        backgroundColor: '#6366f1',
        borderRadius: '2px',
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    divider: {
        height: '1px',
        backgroundColor: '#f3f4f6',
        margin: '12px 8px',
    },
    footer: {
        padding: '16px',
        borderTop: '1px solid #f3f4f6',
        textAlign: 'center',
    },
    footerText: {
        fontSize: '12px',
        color: '#d1d5db',
    },
};
//# sourceMappingURL=sidebar.js.map